export default __webpack_public_path__ + "static/media/withdrawal.b4707582.webp";